import React from 'react'
import ReactDOM from 'react-dom/client'
import FlashMessage from '../components/shared/FlashMessage'

export function validateEmail(email) {
  const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
  return re.test(email)
}

export function showFlashMessage(message, mode) {
  const elmId = 'flash-message'
  let div = document.getElementById(elmId)
  if(div) {
    div.remove()
  }
  div = document.createElement('div')
  div.setAttribute('id', elmId)
  document.body.appendChild(div)

  const root = ReactDOM.createRoot(div)
  root.render(
    <FlashMessage flashMessage={message} flashMessageMode={mode} />
  )
}
